<kendo-buttongroup [width]="'100%'" style="overflow: auto" [ngClass]="{ 'vertical-group': showVertical || smallView }">
   <button
      *ngFor="let actionId of actionIds$ | async; let i = index"
      [disabled]="!(brickInstanceId | isUserActionExecutable$: toolbarId:actionId | async)"
      (click)="executeAction(actionId)"
      kendoButton
      class="sam-toggle-button"
      [selected]="brickInstanceId | isUserActionToggled$: toolbarId:actionId | async"
   >
      <samweb-toolbar-action-item
         [brickInstanceId]="brickInstanceId"
         [actionId]="actionId"
         [toolbarId]="toolbarId"
         [smallView]="smallView"
      ></samweb-toolbar-action-item>
   </button>
</kendo-buttongroup>
